























































































































































































import {Component, Vue, Prop} from 'vue-property-decorator';
import { setNameLang, makeToast } from '@/modules/budget-request/components/js/some-functions';
import store from '@/services/store';
import CAddModal from '@/modules/budget-request/budget-gkkp/c-add-modal.vue';
import CNumberInput from '@/components/c-number-input/index.vue';

@Component({
    components: {
        'c-add-modal': CAddModal,
        'c-number-input': CNumberInput
    },
    name: 'c-limit-gkkp'
})
export default class CLimitGkkp extends Vue {

    @Prop({
        required: true,
        default: null
    })
    private curAbpProp!: any | null;

    @Prop({
        required: true,
        default: null
    })
    private curVariantProp!: any | null;

    @Prop({
        required: true,
        default: null
    })
    private curPeriodProp!: any | null;

    @Prop({
        required: true,
        default: null
    })
    private dataTypeProp!: any | null;

    @Prop({
        required: true,
        default: null
    })
    private curGuProp!: any | null;

    @Prop({
        required: true,
        default: null
    })
    private variantEndDateProp!: any | null;

    @Prop({
        required: true,
        default: null
    })
    private curRegionProp!: any | null;

    // --параметры для модального добавления
    private nameDict = 'программы';
    private codeDict = 'prg';

    private curGu: any | null = null;

    @Prop({
        required: true,
        default: false
    })
    private editableProp!: boolean;

    private get editable() {
        return this.editableProp;
    }

    private progress = 0;
    private collapseAll = false;
    private checkedAll = false;

    private curAbp: any | null = null;
    private curVariant: any | null = null;
    private curYear: number | null = null;
    private dataType: any | null = null;
    private curRegion: any | null = null;
    private variantEndDate: string | null = null;

    private dataLst: any[]= [];

    private totalLimit: any = { value1: null, value2: null, value3: null };
    private totalSum: any = { value1: 0, value2: 0, value3: 0 };

    // -- список программ
    private progBase: any[] = [];
    private curIndxPrg: number | null = null; // программа к которой добавляется подпрограмма или ГУ
    private curIndxPpr: number | null = null; // подпрограмма к которой добавляется ГУ
    private gkkpBase: any[] = [];

    private mounted() {
        this.curAbp = this.curAbpProp;
        this.curVariant = this.curVariantProp;
        if (this.curPeriodProp) { this.curYear = this.curPeriodProp.year; }
        this.dataType = this.dataTypeProp;
        this.curRegion = this.curRegionProp;
        this.variantEndDate = this.variantEndDateProp;
        this.curGu = this.curGuProp;
        this.loadAll();
    }

    /**
     * изменение фильтра
     * @param params
     */
     public chgEvent(params: any) {
        this.curAbp = params.curAbp;
        this.curVariant = params.curVariant;
        this.curYear = params.curYear;
        this.dataType = params.dataType;
        this.curRegion = params.regionProp;
        this.curGu = params.curGu;
        this.variantEndDate = params.variantEndDate;
        this.loadAll();
    }

    private async loadAll() {
        this.loadProgLst();
        this.loadData();
    }

    /**
     * загрузить данные ВСЕГО ЛИМИТ
     */
    private async loadTotalLimit() {
        if (!this.curAbp || !this.curVariant || !this.curYear || !this.curGu) {
            return;
        }
        const params = { abp: this.curAbp.abp, variant: this.curVariant.variant_uuid, curYear: this.curYear, guMain: this.curGu.code };

        const url = `/api-py/get-budget-gkkp-limit-total-sum/${encodeURI(JSON.stringify(params))}`;
        let response: any = [];
        try {
            response = await fetch(url);
            if (response.status === 200) {
                response = await response.json();
                for (let i = 1; i < 4; i++) {
                    if (response[`value${i}`] === undefined) {
                        response[`value${i}`] = null;
                    } else {
                        response[`value${i}`] = Math.round(response[`value${i}`]*10) / 10;
                    }
                }
                this.totalLimit = response;
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки get-budget-gkkp-limit-total-sum', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            response = [];
            makeToast(this, 'danger', 'Ошибка загрузки get-budget-gkkp-limit-total-sum', (error as Error).toString());
        }
    }

    private async loadData() {
        this.dataLst = [];
        this.totalLimit = { value1: null, value2: null, value3: null };
        this.totalSum = { value1: 0, value2: 0, value3: 0 };
        if (!this.curAbp || !this.curVariant || !this.curYear || !this.dataType || !this.curRegion || !this.curGu) {
            return;
        }

        this.progress = 40;
        const params = { abp: this.curAbp.abp, variant: this.curVariant.variant_uuid, curYear: this.curYear, dataType: this.dataType.code, region: this.curRegion.code, guMain: this.curGu.code };
        this.loadTotalLimit();
        this.loadGkkpLst();
        this.progress = 60;
        this.dataLst = await this.loadSavedData(params);
        this.progress = 80;
        if (!this.dataLst.length) {  this.dataLst = await this.loadFirstData(params); }
        this.progress = 100;
    }

    /**
     * получить головное предприятие
     */
    /*private async loadMainGu() {
        this.guMain = null;
        if (!this.curRegion || !this.curAbp) { return; }
        const url = `/api-py/get-gu-main-by-region-abp/${this.curRegion.code}/${this.curAbp.abp}`;
        let response: any = [];
        try {
            response = await fetch(url);
            if (response.status === 200) {
                response = await response.json();
                this.guMain = response;
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки get-gu-main-by-region-abp', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            response = [];
            makeToast(this, 'danger', 'Ошибка загрузки get-gu-main-by-region-abp', (error as Error).toString());
        }
    }*/

    /**
     * загрузка сохранённых данных из budget_limit_gkkp
     * @param params параметры
     */
     private async loadSavedData(params: any) {
        const url = `/api-py/get-budget-limit-gkkp/${encodeURI(JSON.stringify(params))}`;
        let response: any = [];
        try {
            response = await fetch(url);
            if (response.status === 200) {
                response = await response.json();
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки get-budget-limit-gkkp', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            response = [];
            makeToast(this, 'danger', 'Ошибка загрузки get-budget-limit-gkkp', (error as Error).toString());
        }
        return this.getSavedData(response);
    }

    /**
     * сформировать данные из loadSavedData
     * @param response
     */
     private getSavedData(response: any[], first = false) {
        const result: any[] = [];
        const data = [...response];
        data.sort((a: any, b: any) => (a.prg.prg > b.prg.prg) ? 1 : -1);
        for (const el of data) {
            if (!result.length || result[result.length - 1].prg.prg !== el.prg.prg) {
                result.push({prg: el.prg, pprLst: [el], value1: 0, value2: 0, value3: 0, proc2: 0, proc3: 0, sumVl1: 0, sumVl2: 0, sumVl3: 0, collapse: this.collapseAll, checked: this.checkedAll});
            } else {
                result[result.length-1].pprLst.push(el);
            }
        }

        for (const el of result) {
            el.pprLst.sort((a: any, b: any) => (a.ppr.ppr > b.ppr.ppr) ? 1 : -1);
            const pprLst: any[] = [];
            for (const elPpr of el.pprLst) {
                if (!pprLst.length || elPpr.ppr.ppr !== pprLst[pprLst.length-1].ppr.ppr) {
                    pprLst.push({ppr: elPpr.ppr, gkkpLst: [], value1: 0, value2: 0, value3: 0, proc2: 0, proc3: 0, sumVl1: elPpr.sum_vl1 || 0, sumVl2: elPpr.sum_vl2 || 0, sumVl3: elPpr.sum_vl3 || 0, collapse: this.collapseAll, checked: this.checkedAll})
                    for (let i = 1; i < 4; i++) { el[`sumVl${i}`] += elPpr[`sum_vl${i}`]; }
                }
                if (elPpr.gkkp) {
                    const gkkpObj = Object.assign({proc2: 0, proc3: 0, checked: this.checkedAll}, elPpr);
                    for (let i = 1; i < 4; i++) {
                        this.calcProc(gkkpObj, i);
                        pprLst[pprLst.length-1][`value${i}`]+=gkkpObj[`value${i}`];
                        el[`value${i}`]+=gkkpObj[`value${i}`];
                        this.totalSum[`value${i}`] += gkkpObj[`value${i}`];
                        this.calcProc(pprLst[pprLst.length -1], i);
                        this.calcProc(el, i);
                    }
                    pprLst[pprLst.length-1].gkkpLst.push(gkkpObj);
                }
            }
            el.pprLst = pprLst;
        }

        for (const prgGroup of result) {
            if (first) {
                this.setExistsPpr(prgGroup);
                if (prgGroup.pprLst.length && prgGroup.pprLst[0].ppr.ppr === null) { prgGroup.pprLst.splice(0, 1); }
            }
            prgGroup.pprLst.sort((a: any, b: any) => a.ppr.ppr - b.ppr.ppr);
            if (prgGroup.pprLst.length && prgGroup.pprLst[0].ppr.ppr === null) { prgGroup.pprExists = false; }
            for (const pprGroup of prgGroup.pprLst) {
                pprGroup.gkkpLst.sort((a: any, b: any) => a.gkkp.bin - b.gkkp.bin);
            }
        }
        return result;
     }

    /**
    *Загрузка первичных данных
    */
    private async loadFirstData(params: any) {
        const url = `/api-py/get-budget-gkkp-limit-first/${encodeURI(JSON.stringify(params))}`;
        let response: any = [];
        try {
            response = await fetch(url);
            if (response.status === 200) {
                response = await response.json();
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки get-budget-gkkp-limit-first', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            response = [];
            makeToast(this, 'danger', 'Ошибка загрузки get-budget-gkkp-limit-first', (error as Error).toString());
            return [];
        }
        return await this.getSavedData(response, true);
    }

    /**
     * изменение checkbox
     * @param prgIndx
     * @param gkkpIndx
     */
     private clkCheck(prgIndx: number | null, pprIndx: number | null, gkkpIndx: number | null) {
        if (prgIndx === null) {
            for (const el of this.dataLst) {
                this.$set(el, 'checked', this.checkedAll);
                for (const pprEl of el.pprLst) {
                    this.$set(pprEl, 'checked', this.checkedAll);
                    for (const elGu of pprEl.gkkpLst) {
                        this.$set(elGu, 'checked', this.checkedAll);
                    }
                }
            }
            return;
        }
        let checked = false;
        if (pprIndx === null) {
            checked = this.dataLst[prgIndx].checked;
            for (const pprEl of this.dataLst[prgIndx].pprLst) {
                this.$set(pprEl, 'checked', checked);
                for (const elGkkp of pprEl.gkkpLst) {
                    this.$set(elGkkp, 'checked', checked);
                }
            }
        } else {
            if (gkkpIndx === null) {
                checked = this.dataLst[prgIndx].pprLst[pprIndx].checked;
                for (const guEl of this.dataLst[prgIndx].pprLst[pprIndx].gkkpLst) {
                    this.$set(guEl, 'checked', checked);
                }
            } else {
                checked = this.dataLst[prgIndx].pprLst[pprIndx].gkkpLst[gkkpIndx].checked;
                if (this.dataLst[prgIndx].pprLst[pprIndx].checked && !checked) {
                    this.dataLst[prgIndx].pprLst[pprIndx].checked = false;
                } else if (!this.dataLst[prgIndx].pprLst[pprIndx].checked && checked) {
                    this.dataLst[prgIndx].pprLst[pprIndx].checked = this.dataLst[prgIndx].pprLst[pprIndx].gkkpLst.every((item: any) => item.checked);
                }
            }
            if (!checked && this.dataLst[prgIndx].checked) {
                this.dataLst[prgIndx].checked = false;
            } else if (!this.dataLst[prgIndx].checked && checked) {
                this.dataLst[prgIndx].checked = this.dataLst[prgIndx].pprLst.every((item: any) => item.checked);
            }
        }
        if (this.checkedAll && !checked) {
            this.checkedAll = false;
        } else if (!this.checkedAll && checked) {
            this.checkedAll = this.dataLst.every((item: any) => item.checked);
        }
    }

        /**
     * сворачивать программы
     * @param indx индекс программ
     */
     private clkCollapse(indx: number | null, pprIndx: number | null) {
        if (indx === null) {
            this.collapseAll = !this.collapseAll;
            for (const el of this.dataLst) {
                this.$set(el, 'collapse', this.collapseAll);
            }
        } else {
            let collapse = false;
            if (pprIndx == null) {
                collapse = !this.dataLst[indx].collapse;
                this.$set(this.dataLst[indx], 'collapse', collapse);
            } else {
                collapse = !this.dataLst[indx].pprLst[pprIndx].collapse;
                this.$set(this.dataLst[indx].pprLst[pprIndx], 'collapse', collapse);
            }
            if (this.collapseAll && !collapse) {
                for (const el of this.dataLst) {
                    if (el.collapse) { return; }
                }
                this.collapseAll = false;
            } else if (!this.collapseAll && collapse) {
                for (const el of this.dataLst) {
                    if (!el.collapse) { return; }
                }
                this.collapseAll = true;
            }
        }
    }

    /**
     * удалить отмеченные
     */
     private delSelected() {
        let fl = false;
        for (let i = 0; i < this.dataLst.length; i++) {
            if (i < 0) { break; }
            if (this.dataLst[i].checked) {
                this.delRow(i, null, null);
                fl = true;
                i--;
            } else {
                for (let j = 0; j < this.dataLst[i].pprLst.length; j++) {
                    if (j < 0) {break;}
                    if (this.dataLst[i].pprLst[j].checked) {
                        this.delRow(i, j, null);
                        fl = true;
                        j--;
                    } else {
                        for (let k = 0; k < this.dataLst[i].pprLst[j].gkkpLst.length; k++){
                            if (k < 0) { break; }
                            if (this.dataLst[i].pprLst[j].gkkpLst[k].checked) {
                                this.delRow(i, j, k);
                                fl = true;
                                k--;
                            }
                        }
                    }
                }
            }
        }
        if (!fl) {
            makeToast(this, 'warning', 'Удаление', 'Нет отмеченных строк');
        }
    }

    /**
     * удалить строку
     * @param prgIndx индекс программы
     * @param guIndx индекс gu
     */
     private delRow(prgIndx: number, pprIndx: number | null, gkkpIndx: number | null) {
        if (pprIndx === null) {
            for (let i=1; i < 4; i++) {
                this.totalSum[`value${i}`] -=this.dataLst[prgIndx][`value${i}`];
            }
            this.dataLst.splice(prgIndx, 1);
        } else if (gkkpIndx === null) {
            const pprEl = this.dataLst[prgIndx].pprLst[pprIndx];
            this.dataLst[prgIndx].plan -= pprEl.plan;
            for (let i = 1; i < 4; i++) {
                this.dataLst[prgIndx][`value${i}`] -= pprEl[`value${i}`];
                this.totalSum[`value${i}`] -= pprEl[`value${i}`];
            }

            this.dataLst[prgIndx].pprLst.splice(pprIndx, 1);
        } else {
            const guEl = this.dataLst[prgIndx].pprLst[pprIndx].gkkpLst[gkkpIndx];
            this.dataLst[prgIndx].plan -= guEl.plan;
            this.dataLst[prgIndx].pprLst[pprIndx].plan -= guEl.plan;
            for (let i = 1; i < 4; i++) {
                this.dataLst[prgIndx][`value${i}`] -= guEl[`value${i}`];
                this.dataLst[prgIndx].pprLst[pprIndx][`value${i}`] -= guEl[`value${i}`];
                this.totalSum[`value${i}`] -= guEl[`value${i}`];
            }
            this.dataLst[prgIndx].pprLst[pprIndx].gkkpLst.splice(gkkpIndx, 1);
        }
    }

    /**
     * добавить программу
     */
    private addProg() {
        const dictLst = [];
        this.nameDict = 'программы';
        this.codeDict = 'prg';
        for (const el of this.progBase) {
            let fl = false;
            for (let i = 0; i < this.dataLst.length; i++) {
                if (this.dataLst[i].prg.prg === el.prg) {
                    fl = true;
                    break;
                }
            }
            if (!fl) { dictLst.push(el); }
        }

        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.addModalRef.openModal(dictLst);
    }

    /**
     * добавить ГККП
     */
    private addGkkp(indx: number, pprIndx: number) {
        const dictLst = [];
        this.nameDict = 'ГККП';
        this.codeDict = 'bin';
        for (const el of this.gkkpBase) {
            let fl = false;
            for (let i = 0; i < this.dataLst[indx].pprLst[pprIndx].gkkpLst.length; i++) {
                if (this.dataLst[indx].pprLst[pprIndx].gkkpLst[i].gkkp.bin === el.bin) {
                    fl = true;
                    break;
                }
            }
            if (!fl) { dictLst.push(el); }
        }
        this.curIndxPrg = indx;
        this.curIndxPpr = pprIndx;

        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.addModalRef.openModal(dictLst);
    }

    /**
     * ввод цифр
     */
     private noAbc(evt: any) {
        // eslint-disable-next-line require-unicode-regexp
        const regex = new RegExp('^-?\\d*\\.?\\d{0,9}$');
        const key = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
        if (!regex.test(key)) {
            evt.preventDefault();
            return false;
        }
    }

        /**
     * изменение значения лимита
     * @param obj объект gkkpLst
     * @param fieldNumber номер поля 1-3
     * @param indx индекс dataLst
     */
     private chgValue(obj: any, fieldNumber: number, indx: number, pprIndx: number) {
        const fieldName = `value${fieldNumber}`
        if (isNaN(obj[fieldName]) || obj[fieldName]==='') { this.$set(obj, fieldName, 0); }
        obj[fieldName] = Math.abs((Math.round(parseFloat(obj[fieldName]) * 10))/10);
        this.calcProc(obj, fieldNumber);
        this.calcTotalVal(this.dataLst[indx].pprLst[pprIndx], 'gkkpLst');
        this.calcTotalVal(this.dataLst[indx], 'pprLst');
        for (let i=1; i < 4; i++) {
            this.calcProc(this.dataLst[indx].pprLst[pprIndx], i);
            this.calcProc(this.dataLst[indx], i);
        }
        const totalSum: any = { value1: 0, value2: 0, value3: 0 };
        for (const el of this.dataLst) {
            for (let i = 1; i < 4; i++) {
                totalSum[`value${i}`] += Math.round(el[`value${i}`]*10)/10;
            }
        }
        this.totalSum = totalSum;
    }

    private calcTotalVal(obj: any, lstName: string) {
        let value1 = 0;
        let value2 = 0;
        let value3 = 0;
        for (const el of obj[lstName]) {
            value1+=el.value1;
            value2+=el.value2;
            value3+=el.value3;
        }
        this.$set(obj, 'value1', Math.round(value1*10)/10);
        this.$set(obj, 'value2', Math.round(value2*10)/10);
        this.$set(obj, 'value3', Math.round(value3*10)/10);
    }

    private calcProc(obj: any, fieldNumber: number) {
        if (fieldNumber > 1) {
            if (obj[`value${fieldNumber-1}`]){
                obj[`proc${fieldNumber}`] = Math.round(obj[`value${fieldNumber}`] / obj[`value${fieldNumber-1}`] * 1000) / 10;
            } else {
                obj[`proc${fieldNumber}`] = 0;
            }
        } else {
            if (obj.value1) {
                obj.proc2 = Math.round(obj.value2 / obj.value1 * 1000) / 10;
            } else {
                obj.proc2 = 0;
            }
        }
    }

        /**
     *  сохранить
     */
     private async saveClk() {
        if (!this.editable) { return; }
        if (this.progress > 0 && this.progress < 100) { return; }
        if (this.totalLimit && this.totalSum && this.dataLst.length) {
            for (let i = 1; i < 4; i++) {
                if (this.totalLimit[`value${i}`]===null) {
                    makeToast(this, 'danger', 'Сохранение', 'Сохранение не возможно, так как не определены общие лимиты по ГУ (строка ВСЕГО ЛИМИТ не заполнена)');
                    return;
                } else if ((this.totalLimit[`value${i}`] - this.totalSum[`value${i}`])<0) {
                    makeToast(this, 'danger', 'Сохранение', 'Остаток по лимиту не может быть отрицательным. Проверьте данные!');
                    return;
                 }
            }
        }
        if (this.curGu === null) {
            makeToast(this, 'danger', 'Ошибка сохранения', 'Нет головного предприятия');
            return;
        }
        const saveObj: any = { variant: this.curVariant.variant_uuid, abp: this.curAbp.abp, curYear: this.curYear, usrId: store.state.user.sub, gu_main: this.curGu.code, valueLst: [] };
        for (const el of this.dataLst) {
            for (const elPpr of el.pprLst) {
                for (const gkkpEl of elPpr.gkkpLst) {
                    if (gkkpEl.value1 < 0 || gkkpEl.value2 < 0 || gkkpEl.value3 < 0) {
                        makeToast(this, 'danger', 'Ошибка сохранения', 'Ввод отрицательных чисел запрещен!');
                        return;
                    }
                    if (gkkpEl.value1 || gkkpEl.value2 || gkkpEl.value3) {
                        const obj = { gkkp: gkkpEl.gkkp.bin, prg: el.prg.prg, ppr: elPpr.ppr.ppr, value1: gkkpEl.value1, value2: gkkpEl.value2, value3: gkkpEl.value3 }
                        saveObj.valueLst.push(obj);
                    }
                }
            }
        }
        try {
            const url = '/api-py/budget-limit-gkkp-save';
            let response: any = await fetch(url, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(saveObj)
            });
            response = await response.json();
            for (const el of response) {
                if (el.result !== 'success') {
                    makeToast(this, 'danger', 'Ошибка сохранения', el.result);
                    return;
                }
            }
            makeToast(this, 'success', 'Сообщение', 'Данные сохранены');

        } catch (error) {
            makeToast(this, 'danger', 'Ошибка сохранения', (error as Error).toString());
        }
    }

    /**
     * загрузка списка программ
     */
    private async loadProgLst() {
        if (!this.curAbp) { return; }
        let response: any = [];
        try {
            response = await fetch(`/api-py/get-dict-func-childs-by-parent-code/${encodeURI(JSON.stringify({type: 4, abp: this.curAbp.abp}))}`);
            if (response.status === 200) {
                response = await response.json();
                this.progBase = response;
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки программ', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки программ', (error as Error).toString());
        }
    }

    /**
     * загрузка списка ГККП
     */
     private async loadGkkpLst() {
        if (!this.curGu) { return; }
        let response: any = [];
        try {
            response = await fetch(`/api-py/get-kgkp-by-gu-date/${this.curGu.code}/${this.curVariant.date_start}/${this.variantEndDate}`);
            if (response.status === 200) {
                response = await response.json();
                this.gkkpBase = response;
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки ГККП', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки ГККП', (error as Error).toString());
        }
    }

    /**
     * кнопка добавить с модального окна
     */
     private async addModalClk(items: any[]) {
        if (this.codeDict === 'prg') { // добавление программ
            for (const el of items) {
                if (el.pprExists === undefined || el.pprExists === null) {
                    el.pprExists = await this.loadExistsPpr(el.prg);
                }
                const pprLst: any[] = [];
                if (el.pprExists === false) {
                    pprLst.push({ gkkpLst: [], plan: 0, ppr: { ppr: null, name_ru: null, name_kk: null }, value1: 0, value2: 0, value3: 0, proc1: 0, proc2: 0, proc3: 0, sumVl1: 0, sumVl2: 0, sumVl3: 0, collapse: this.collapseAll, checked: this.checkedAll });
                }
                const obj = { pprLst: pprLst, pprExists: el.pprExists, plan: 0, prg: { prg: el.prg, name_ru: el.name_ru, name_kk: el.name_kk }, value1: 0, value2: 0, value3: 0, sumVl1: null, sumVl2: null, sumVl3: null, proc2: 0, proc3: 0,  collapse: this.collapseAll, checked: this.checkedAll }
                this.dataLst.push(obj);
            }
            this.dataLst.sort((a: any, b: any) => (a.prg.prg > b.prg.prg) ? 1 : -1);
            this.loadProgValSum(items);
        } else if (this.codeDict === 'ppr') { // добавление подпрограмм
            if (this.curIndxPrg === null) { return; }
            for (const el of items) {
                const obj = { gkkpLst: [], plan: 0, ppr: { ppr: el.ppr, name_ru: el.name_ru, name_kk: el.name_kk }, value1: 0, value2: 0, value3: 0, proc1: 0, proc2: 0, proc3: 0, sumVl1: 0, sumVl2: 0, sumVl3: 0, collapse: this.collapseAll, checked: this.checkedAll }
                this.dataLst[this.curIndxPrg].pprLst.push(obj);
            }
            this.dataLst[this.curIndxPrg].pprLst.sort((a: any, b: any) => (a.ppr.ppr > b.ppr.ppr) ? 1 : -1);
            this.loadSubProgValSum(items);
        } else { // добавление ГККП
            if (this.curIndxPrg === null || this.curIndxPpr === null) { return; }
            for (const el of items) {
                const obj = {gkkp: { bin: el.bin, name_ru: el.name_ru, name_kk: el.name_kk }, proc2: 0, proc3: 0, value1: 0, value2: 0, value3: 0, checked: this.checkedAll};
                this.dataLst[this.curIndxPrg].pprLst[this.curIndxPpr].gkkpLst.push(obj);
            }
            this.dataLst[this.curIndxPrg].pprLst[this.curIndxPpr].gkkpLst.sort((a: any, b: any) => (a.gkkp.bin > b.gkkp.bin) ? 1 : -1);
        }
     }

     // -----------------------------------
     /**
      * подгрузка суммы лимитов для программ из budget_limit_gu
      */
     private async loadProgValSum(items: any[]) {
        if (!this.curAbp || !this.curVariant || !this.curYear || !this.curGu || !items.length) {
            return;
        }

        const params: any = { abp: this.curAbp.abp, variant: this.curVariant.variant_uuid, curYear: this.curYear, prg: [], guMain: this.curGu.code };
        for (const item of items) {
            params.prg.push(item.prg);
        }
        let response: any = [];
        try {
            response = await fetch(`/api-py/get-budget-gkkp-limit-sum-by-prog/${encodeURI(JSON.stringify(params))}`);
            if (response.status === 200) {
                response = await response.json();
                this.setProgValSum(response);
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки get-budget-gkkp-limit-sum-by-prog', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки get-budget-gkkp-limit-sum-by-prog', (error as Error).toString());
        }
    }

     // -----------------------------------
     /**
      * подгрузка суммы лимитов для подпрограмм из budget_limit_gu
      */
      private async loadSubProgValSum(items: any[]) {
        if (!this.curAbp || !this.curVariant || !this.curYear || !this.curGu || !items.length) {
            return;
        }

        const params: any = { abp: this.curAbp.abp, variant: this.curVariant.variant_uuid, curYear: this.curYear, prg: items[0].prg, pprLst: [], guMain: this.curGu.code };
        for (const item of items) {
            params.pprLst.push(item.ppr);
        }
        let response: any = [];
        try {
            response = await fetch(`/api-py/get-budget-gkkp-limit-sum-by-subprog/${encodeURI(JSON.stringify(params))}`);
            if (response.status === 200) {
                response = await response.json();
                this.setPprValSum(response, items[0].prg);
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки get-budget-gkkp-limit-sum-by-subprog', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки get-budget-gkkp-limit-sum-by-subprog', (error as Error).toString());
        }
    }

    /**
     * проставить суммы лимитов для подпрограмм из budget_limit_gu
     * @param response
     */
     private setPprValSum(response: any[], prg: number) {
        const prgObj = this.dataLst.find((p: any) => p.prg.prg === prg);
        const sumVlprog: any = {sumVl1: prgObj.sumVl1, sumVl2: prgObj.sumVl2, sumVl3: prgObj.sumVl3};
        for (const el of response) {
            for (let i = 0; i < prgObj.pprLst.length; i++) {
                if (prgObj.pprLst[i].ppr.ppr === el.ppr) {
                    for (let j = 1; j < 4; j++) {
                        this.$set(prgObj.pprLst[i], `sumVl${j}`, el[`sum_vl${j}`]);
                        if (el[`sum_vl${j}`]) { sumVlprog[`sumVl${j}`] += el[`sum_vl${j}`]; }
                    }
                    break;
                }
            }
            for (let j = 1; j < 4; j++) {
                this.$set(prgObj, `sumVl${j}`, sumVlprog[`sumVl${j}`]);
            }
        }
    }

    /**
     * проставить суммы лимитов для программ из budget_limit_gu
     * @param response
     */
    private setProgValSum(response: any[]) {
        for (const el of response) {
            for (let i = 0; i < this.dataLst.length; i++) {
                if (this.dataLst[i].prg.prg === el.prg) {
                    for (let j = 1; j < 4; j++) {
                        this.$set(this.dataLst[i], `sumVl${j}`, el[`sum_vl${j}`]);
                    }
                    break;
                }
            }
        }
    }
    // ----------------------------------

    /**
     * добавить подпрограмму
     */
     private addSubProg(indx: number) {
        this.nameDict = 'подпрограммы';
        this.codeDict = 'ppr';
        this.curIndxPrg = indx;
        const data = this.dataLst[indx];
        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.addModalRef.loadSubProgLst(this.curAbp, data.prg, data.pprLst);
    }

    private async loadExistsPpr(prg: number) {
        if (!this.curAbp) { return null; }
        const elBase = this.progBase.find((item: any) => item.prg === prg);
        if (!elBase) { return null; }
        if (elBase.pprExists!==undefined && elBase.pprExists!==null) { return elBase.pprExists; }
        let response: any = [];
        try {
            response = await fetch(`/api-py/get-dict-func-subprog-exists/${encodeURI(JSON.stringify({abp: this.curAbp.abp, prg: prg}))}`);
            response = await response.json();
            elBase.pprExists = response.pprExists;
            return response.pprExists;
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки программ', (error as Error).toString());
            return null
        }
    }

    // проставить pprExists, сущетсвует ли ppr для данной программы
    private async setExistsPpr(prgGroup: any) {
        if (prgGroup.pprLst.length === 0) {
            prgGroup.pprExists = false;
            prgGroup.pprLst.push({
                gkkpLst: [], plan: 0, ppr: { ppr: null, name_ru: null, name_kk: null }, value1: 0, value2: 0, value3: 0, proc1: 0, proc2: 0, proc3: 0, sumVl1: 0, sumVl2: 0, sumVl3: 0, collapse: this.collapseAll, checked: this.checkedAll
            });
            return;
        }
        if (prgGroup.pprLst[0].ppr.ppr !== null) { return; }
        // --- врядли сюда попадёт, но на всякий случай
        prgGroup.pprExists = await this.loadExistsPpr(prgGroup.prg.prg);
        if (!prgGroup.pprExists) {
            prgGroup.pprLst = [{
                gkkpLst: [], plan: 0, ppr: { ppr: null, name_ru: null, name_kk: null }, value1: 0, value2: 0, value3: 0, proc1: 0, proc2: 0, proc3: 0, sumVl1: 0, sumVl2: 0, sumVl3: 0, collapse: this.collapseAll, checked: this.checkedAll
            }];
        }
        // ---
    }
}
